import React from 'react';
import { Container } from "@mui/material";
import Header from "./Header";
import Footer from "./Footer";

type LayoutProps = {
  children: JSX.Element;
};

export default function Layout(props: LayoutProps) {
  return (
    <Container maxWidth="lg">
      <Header />
      {props.children}
      <Footer />
    </Container>
  );
}
